import { Funnel } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";

export const AddFilterPill = ({
  onClick,
  activeFilterCount,
}: {
  onClick?: () => void;
  activeFilterCount: number;
}) => {
  const { t } = useTranslation();
  return (
    <button
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) onClick();
      }}
      className="flex h-5.5 items-center gap-1.5 rounded-full border bg-background-light px-2 text-xs hover:border-border-dark"
    >
      <Funnel strokeWidth={3} size={12} />
      {activeFilterCount > 0 ? (
        <>
          <div className="text-black dark:text-white">
            {t("global.filters")}
          </div>
          <div className="mr-[-3px] rounded-full bg-primary px-2 leading-[15px] text-background">
            {activeFilterCount}
          </div>
        </>
      ) : (
        <div>{t("global.addFilter")}</div>
      )}
    </button>
  );
};
